<template>
  <BaseButton
    small
    block
    :color="computedColor"
    :text-color="computedTextColor"
    :md-icon="mdIcon"
    md-icon-position="left"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </BaseButton>
</template>

<script>
import BaseButton from '@components/Base/Button'

export default {
  name: 'ButtonEditControl',
  components: { BaseButton },
  props: {
    mdIcon: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedColor() {
      if (this.danger) return 'red darken-1'
      return this.active ? 'blue darken-2' : 'grey lighten-5'
    },
    computedTextColor() {
      return this.active || this.danger ? 'white' : 'grey darken-2'
    },
  },
}
</script>

<style scoped>
::v-deep .v-icon--left {
  margin-right: 8px;
}
</style>
